import React, { Fragment, useContext } from 'react'

import AuthContext from '../context/auth/auth-context';
import Login from '../components/Login'

import KathleenStern from '../assets/images/kathleen_stern.jpg';
import '../assets/scss/containers.scss';

const Home = () => {

  const authContext = useContext(AuthContext);
  const isLoggedIn = authContext;

  return (
    <Fragment>
      { isLoggedIn ? (<Auth />) : (<Dashboard />) }
    </Fragment>
  )
}

const Auth = () => {
  return (
    <div className="fiterr-app-section">
      <div className="fiterr-app-inner-wrapper">
        <div className="fiterr-app-page-container login">
          <Login />
        </div>
      </div>
    </div>
  )
}

const Dashboard = () => {
  return (
    <div className="fiterr-app-section">
      <div className="fiterr-app-inner-wrapper">
        <div className="fiterr-app-page-container">
          <div className="dashboard-welcome-wrapper">
            <div className="dashboard-welcome-image">
              <img src={KathleenStern} alt=""></img>
            </div>
            <div className="dashboard-welcome-message">
              Hi [first_name], welcome to your Dashboard! 😍 
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home;